import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { useReturnToJobPage } from '@xing-com/crate-jobs-domain-apply-hooks';
import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaConfined } from '@xing-com/layout-tokens';
import { ModalPage } from '@xing-com/modal-page';
import { spaceL, spaceXL } from '@xing-com/tokens';
import { BodyCopy, Headline } from '@xing-com/typography';

const StyledGridItem = styled(GridItem)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spaceL};
  text-align: center;

  @media ${mediaConfined} {
    gap: ${spaceXL};
  }
`;

type Props = { refetch: () => void };

export const LoadingError: React.FC<Props> = ({ refetch }) => {
  const returnToJobPage = useReturnToJobPage();

  return (
    <ModalPage
      noGrid
      noMargin
      data-testid="loading-error"
      closeButton={{
        onClick: returnToJobPage,
      }}
    >
      <GridContainer variant="FullSize">
        <StyledGridItem span={10} start={2} spanLarge={6} startLarge={4}>
          <Headline size="large" noMargin>
            <FormattedMessage id="JOBS_APPLY_LOADING_ERROR_HEADLINE" />
          </Headline>
          <BodyCopy noMargin>
            <FormattedMessage id="JOBS_APPLY_LOADING_ERROR_BODY" />
          </BodyCopy>
          <Button variant="primary" onClick={refetch}>
            <FormattedMessage id="JOBS_APPLY_LOADING_ERROR_CTA" />
          </Button>
        </StyledGridItem>
      </GridContainer>
    </ModalPage>
  );
};
